import React from "react";
import PageWrapper from "../../components/UI/PageWrapper";
import UsersList from "../../components/Admin/UsersList";

const UsersListPage = () => (
  <PageWrapper>
    <UsersList />
  </PageWrapper>
);

export default UsersListPage;
